import { action, observable } from 'mobx';
import { IFlowGalleryTemplate } from '~/components/FlowGallery/types/flow-gallery.types';
import { OnboardingSequence } from '~/models/onboarding-sequence.model';
import type { RootStore } from '~/stores/root.store';
import { IOnboardingSequence, IRecentActivityItem } from '~/types/server.types';
import { ISODateStringComparator } from '~/utils/automation.utils';
import { LoggerService } from '~/services/logger/logger.service';

export class HomeStore {
    rootStore: RootStore;
    setupGuideLogger: LoggerService;

    @observable onboardingSequence: OnboardingSequence;
    @observable recentActivity: IRecentActivityItem[];
    @observable sendTestTemplates: IFlowGalleryTemplate[];

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;
        this.setupGuideLogger = new LoggerService({
            featureName: 'setup_guide',
            messagePrefix: '[SetupGuide]'
        });
    }

    @action.bound
    setOnboardingSequence(sequence: IOnboardingSequence) {
        this.onboardingSequence = new OnboardingSequence(
            sequence,
            sequence?.is_ai_setup ?? false
        );
    }

    @action.bound
    setRecentActivity(activityItems: IRecentActivityItem[]) {
        this.recentActivity = activityItems
            .sort(ISODateStringComparator)
            .reverse();
    }

    @action.bound
    setSendTestTemplates(templates: IFlowGalleryTemplate[]) {
        this.sendTestTemplates = templates;
    }
}
